export default "__VITE_ASSET__C$m6AqL0__"